// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as $$Promise from "../../../../node_modules/@ryyppy/rescript-promise/lib/es6_global/src/Promise.bs.js";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function useCheckoutAction(param) {
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var settings = match$1.settings;
  var match$2 = EntrypointContext$Showside.use(undefined);
  var redirectToLink = match$2.redirectToLink;
  var trackEvent = match$2.trackEvent;
  var match$3 = CartContextProvider$Showside.useCart(undefined);
  var setShowCartDrawer = match$3.setShowCartDrawer;
  var openLinkInNewTab = settings.openLinkInNewTab;
  var checkoutCustomAction = Belt_Option.flatMap(match$1.transitiveAccount, function (account) {
    return Belt_Array.getBy(account.customActions, function (action) {
      return Caml_obj.equal(Caml_option.some(action.id), settings.checkoutCustomAction);
    });
  });
  var trackCheckout = function (e) {
    Curry.app(trackEvent, ["checkout", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var match$4 = settings.checkoutLink;
  var exit = 0;
  if (setShowCartDrawer !== undefined) {
    if (settings.cart) {
      return {
        href: undefined,
        onClick: function (e) {
          Curry._1(setShowCartDrawer, function (param) {
            return true;
          });
        }
      };
    }
    exit = 2;
  } else {
    exit = 2;
  }
  if (exit === 2 && checkoutCustomAction !== undefined) {
    var code = checkoutCustomAction.onClickFn;
    if (code !== undefined && match$4 !== undefined) {
      return {
        href: undefined,
        onClick: function (e) {
          trackCheckout(e);
          $$Promise.$$catch(CustomScript$Showside.triggerCustomFunctionWithoutProducts(code, "checkout", undefined, undefined), function (param) {
            return Promise.resolve(Belt_Option.forEach(settings.checkoutLink, function (__x) {
              Curry._5(redirectToLink, undefined, undefined, undefined, openLinkInNewTab, __x);
            }));
          });
        }
      };
    }
  }
  if (match$4 !== undefined) {
    return {
      href: match$4,
      onClick: trackCheckout
    };
  } else {
    return {
      href: match$3.storeCheckoutLink,
      onClick: undefined
    };
  }
}
export { useCheckoutAction };
/* CustomScript-Showside Not a pure module */